import { Loader, type LoaderProps } from '@mantine/core';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap: Record<string, LoaderProps['size']> = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
};

export function Spinner({ size = 'md' }: SpinnerProps) {
  return <Loader size={sizeMap[size]} />;
}
